import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { reflectionActions } from '@app/store/reflection/actions/reflection.actions';
import { reflectionsActions } from '../actions/reflections.actions';
import { selectLastParams } from '../selectors/reflections.selector';

@Injectable()
export class ReflectionReflectionsBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    refreshOnMutation$ = createEffect(() => {
        return this.actions.pipe(
            ofType(reflectionActions.createReflectionSuccess, reflectionActions.updateReflectionSuccess, reflectionActions.deleteReflectionSuccess),
            concatLatestFrom(() => this.store.select(selectLastParams)),
            map(([, lastParams]) => reflectionsActions.getReflections({ value: lastParams })),
        );
    });
}
